import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

const STATUS_CLASS = {
  sold: 'band-event-row__pill--sold',
  few: 'band-event-row__pill--few',
};

/**
 * Editorial event row — pixel-matches the `.event` row from the band-page
 * mockup. Pure presentational; the caller supplies a pre-formatted day/month
 * and the action button(s) as JSX nodes.
 */
export default function BandEventRow({
  day,
  month,
  title,
  subtitle,
  venue,
  location,
  description,
  pill,
  pillStatus,
  action,
  className = '',
}) {
  const classes = classNames('band-event-row', className);
  const descriptionTitle = typeof description === 'string' ? description : undefined;

  return (
    <article className={classes}>
      <div className="band-event-row__date">
        <span className="band-event-row__date-day">{day}</span>
        <span className="band-event-row__date-mo">{month}</span>
      </div>
      <div className="band-event-row__main">
        <div className="band-event-row__title">{title}</div>
        {subtitle ? <div className="band-event-row__sub">{subtitle}</div> : null}
        {pill ? (
          <span
            className={classNames('band-event-row__pill', STATUS_CLASS[pillStatus] || '')}
          >
            {pill}
          </span>
        ) : null}
      </div>
      <div className="band-event-row__location">
        {venue ? <strong className="band-event-row__location-name">{venue}</strong> : null}
        {location ? (
          <div
            className={classNames(
              'band-event-row__location-text',
              venue ? 'band-event-row__sub' : '',
            )}
          >
            {location}
          </div>
        ) : null}
      </div>
      <div className="band-event-row__description" title={descriptionTitle}>
        {description}
      </div>
      {action ? <div className="band-event-row__action">{action}</div> : null}
    </article>
  );
}

BandEventRow.propTypes = {
  day: PropTypes.node.isRequired,
  month: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  venue: PropTypes.node,
  location: PropTypes.node,
  description: PropTypes.node,
  pill: PropTypes.node,
  pillStatus: PropTypes.oneOf(['sold', 'few', 'default']),
  action: PropTypes.node,
  className: PropTypes.string,
};
